import { useEffect, useState } from "react";
import api, { apiErr, setToken } from "@/lib/api";
import { toast } from "sonner";
import { Eye, RotateCcw, Repeat, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABEL, niceName } from "@/lib/format";
import { DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

export function ViewAs() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [ensaio, setEnsaio] = useState(null);
  useEffect(() => { api.get("/demo/view-as").then(({ data }) => setList(data)).catch(() => {}); }, []);
  useEffect(() => { api.get("/demo/ensaio").then(({ data }) => setEnsaio(data.can ? data.source : null)).catch(() => {}); }, []);
  const repeat = async () => {
    if (!window.confirm(`Criar uma cópia nova do ${ensaio}, antes da proposta aceite? A cópia de ensaio anterior é apagada.`)) return;
    try { const { data } = await api.post("/demo/ensaio"); toast.success(`Cópia de ensaio pronta · ${data.ref}`); window.location.assign(`/processo/${data.id}`); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const go = async (u) => {
    try {
      const { data } = await api.post(`/demo/view-as/${u.id}`);
      if (data.access_token) setToken(data.access_token);
      window.location.assign("/inicio");
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const reset = async () => {
    if (window.prompt("Repor a demonstração? Tudo o que foi feito desde a última reposição é apagado. Para confirmar, escreva REPOR.")?.trim().toUpperCase() !== "REPOR") return;
    try { await api.post("/demo/reset", { confirm: "REPOR" }); toast.success("Demonstração reposta"); window.location.assign("/inicio"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const exit = async () => {
    try { const { data } = await api.post("/platform/view-as/exit"); if (data.access_token) setToken(data.access_token); window.location.assign("/admin"); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  if (!list.length) return null;
  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold flex items-center gap-1.5"><Eye size={12} /> Ver como</DropdownMenuLabel>
      {list.map((u) => (
        <DropdownMenuItem key={u.id} disabled={u.id === user.id} onClick={() => go(u)} data-testid={`view-as-${u.role}`}>
          <span className="flex-1">{u.label || niceName(u.name)}</span>
          {!u.label && <span className="text-xs text-slate-400">{ROLE_LABEL[u.role]}</span>}
        </DropdownMenuItem>
      ))}
      {ensaio && <DropdownMenuItem onClick={repeat} data-testid="demo-ensaio"><Repeat size={14} className="mr-2" /> Nova cópia para demonstração · {ensaio}</DropdownMenuItem>}
      {ensaio && <DropdownMenuItem onClick={reset} data-testid="demo-reset"><RotateCcw size={14} className="mr-2" /> Repor demonstração</DropdownMenuItem>}
      {user.real_platform_admin && <DropdownMenuItem onClick={exit} data-testid="view-as-exit-admin"><ShieldCheck size={14} className="mr-2" /> Voltar à administração</DropdownMenuItem>}
      <DropdownMenuSeparator />
    </>
  );
}
